import React from "react";
import Radio from "@mui/material/Radio";

const RadioButton = (props) => {
  return (
    <Radio
      {...props}
      sx={{
        height: "40",
        color: "#02172F",
        "&.Mui-checked": {
          color: props.checkedcolor ?? "#F26422",
        },
      }}
    />
  );
};

export default RadioButton;
